import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { HeaderComponent } from './header/header.component';
import { BuscadorComponent } from './buscador/buscador.component';
import { SegmentComponent } from './segment/segment.component';
import { FooterComponent } from './footer/footer.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { GeneralModalsModule } from '../modals/general-modals.module';
import { ProductosMarketplaceHomeComponent } from './productos-marketplace-home/productos-marketplace-home.component';
import { ProductosMarketplaceComponent } from './productos-marketplace/productos-marketplace.component';
import { ModalContactoVendedorComponent } from './modal-contacto-vendedor/modal-contacto-vendedor.component';
import { TextoDecoradorComponent } from './texto-decorador/texto-decorador.component';
import { CardProductosComponent } from './card-productos/card-productos.component';
import { CardGrandeDeProductoComponent } from './card-grande-de-producto/card-grande-de-producto.component';
import { PagerComponent } from './pager/pager.component';
import { PipesModule } from 'src/app/market-place/pipes/pipes.module';
import { ErrorPagoComponent } from './error-pago/error-pago.component';
import { VendedorRespuestaComentariosComponent } from './vendedor-respuesta-comentarios/vendedor-respuesta-comentarios.component';
import { SelectPhoneCodeComponent } from './select-phone-code/select-phone-code.component';
import { BalancePopoverComponent } from './balance-popover/balance-popover.component';
import { EmergenciesComponent } from './emergencies/emergencies.component';
import { BuscadorMarketplaceComponentTienda } from './buscador-marketplace-tienda/buscador-marketplace.component';
import { CompartirWebComponent } from './compartir-web/compartir-web.component';
import { MultioComponent } from './multio/multio.component';
import { LangComponent } from './lang/lang.component';
import { OfertComponent } from './ofert/ofert.component';
import { FiltroUbicacionComponent } from './filtro-ubicacion/filtro-ubicacion.component';
import { MapboxComponent } from './mapbox/mapbox.component';
import { CommentsComponent } from './comments/comments.component';
import { ShareReviewComponent } from './share-review/share-review.component';
import { CommentListComponent } from './comment-list/comment-list.component';
import { ReviewComponentProduct } from './review/review.component';
import { CommentItemComponent } from './comment-item/comment-item.component';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { PasarelaComponent } from './pasarela/pasarela.component';
import { InfiniteScrollComponent } from './infinite-scroll/infinite-scroll.component';
import { ProductListComponent } from './product-list/product-list.component';
import { BuscadorAdminComponent } from './buscador-admin/buscador-admin.component';
import { FiltroMultinivelComponent } from './filtro-multinivel/filtro-multinivel.component';
import { StatsOrderDetailComponent } from './stats-order-detail/stats-order-detail.component';
import { ParentCodeComponent } from './parent-code/parent-code.component';
import { ScheduleComponent } from './schedule/schedule.component';

const declarations = [
  HeaderComponent,
  BuscadorComponent,
  SegmentComponent,
  FooterComponent,
  PreloaderComponent,
  ProductosMarketplaceHomeComponent,
  ProductosMarketplaceComponent,
  ModalContactoVendedorComponent,
  TextoDecoradorComponent,
  CardProductosComponent,
  CardGrandeDeProductoComponent,
  PagerComponent,
  ErrorPagoComponent,
  VendedorRespuestaComentariosComponent,
  SelectPhoneCodeComponent,
  BalancePopoverComponent,
  EmergenciesComponent,
  BuscadorMarketplaceComponentTienda,
  CompartirWebComponent,
  MultioComponent,
  LangComponent,
  OfertComponent,
  FiltroUbicacionComponent,
  MapboxComponent,
  CommentsComponent,
  ShareReviewComponent,
  CommentListComponent,
  ReviewComponentProduct,
  CommentItemComponent,
  PasarelaComponent,
  InfiniteScrollComponent,
  ProductListComponent,
  BuscadorAdminComponent,
  FiltroMultinivelComponent,
  StatsOrderDetailComponent,
  ParentCodeComponent,
  ScheduleComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    GeneralModalsModule,
    ReactiveFormsModule,
    NgxStarRatingModule,
    PipesModule,
  ],
  exports: declarations,
})
export class GeneralesComponentsModule {}
